import { createContext, useContext, useState, useEffect } from "react";
// import { useUser } from "../UserContext";
import axios from "axios";
// import { useHistory } from "react-router";

const MachineryContext = createContext();

export const MachineryProvider = ({ children }) => {

  const [geradorEnergia, setGeradorEnergia] = useState({
    amount: 0,
    value: 80000.0,
  });
  const [maquinaFrango, setMaquinaFrango] = useState({
    amount: 0,
    value: 1920000.0,
    employers: 30
  });
  const [maquinaSalsichao, setMaquinaSalsichao] = useState({
    amount: 0,
    value: 240000.0,
    employers: 20
  });
  const [maquinaFrangoCorte, setMaquinaFrangoCorte] = useState({
    amount: 0,
    value: 2160000.0,
    employers: 90
  });
  const [maquinaFries, setMaquinaFries] = useState({
    amount: 0,
    value: 50000.0,
    employers: 10
  });

  useEffect(() => {

    const storagedIndustry = JSON.parse(localStorage.getItem('@App:industria'));

    if (!storagedIndustry) return

    axios.get(`${process.env.REACT_APP_BASE_URL}/industria/obter/${storagedIndustry?.industria}`)
      .then(response => {
        setGeradorEnergia({
          amount: response.data.gerador ?? 0,
          value: geradorEnergia.value,
        })
        setMaquinaFrango({
          amount: response.data.frangoCarcaca ?? 0,
          value: maquinaFrango.value,
          employers: 30
        })
        setMaquinaFrangoCorte({
          amount: response.data.corteFrango ?? 0,
          value: maquinaFrangoCorte.value,
          employers: 90
        })
        setMaquinaFries({
          amount: response.data.batata ?? 0,
          value: maquinaFries.value,
          employers: 10
        })
        setMaquinaSalsichao({
          amount: response.data.linguica ?? 0,
          value: maquinaSalsichao.value,
          employers: 20
        })

      })
      .catch(error => { return error })

  }, [])

  return (
    <MachineryContext.Provider
      value={{
        geradorEnergia,
        setGeradorEnergia,
        maquinaFrango,
        setMaquinaFrango,
        maquinaSalsichao,
        setMaquinaSalsichao,
        maquinaFrangoCorte,
        setMaquinaFrangoCorte,
        maquinaFries,
        setMaquinaFries,
      }}
    >
      {children}
    </MachineryContext.Provider>
  );
};

export const useMachinery = () => useContext(MachineryContext);
